import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { DebugLogger } from 'lib/debugLogger';
import {
    ANONYM_USER,
    IS_CORP_USER,
    IS_DOCUMENTS_DOMAIN,
    IS_MY_TEAM,
    IS_ONPREMISE,
    IS_PAID_USER,
    IS_PHONE_BROWSER,
    IS_SOCIAL_USER,
} from 'reactApp/appHelpers/configHelpers';
import { AI_PHOTO_GENERATION_PAY_SOURCE } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.constants';
import type { AiPhotoGenerationImageStyleType } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.types';

interface IAiPhotoGenerationStyleItem {
    name: string;
    image_url: string;
    key: AiPhotoGenerationImageStyleType;
}

const FEATURE = 'ai-photo-generation';

const aiPhotoGenerationStylesDefault: IAiPhotoGenerationStyleItem[] = [
    {
        name: 'Картина маслом',
        image_url: 'https://cloud-divkit-images.cdn-vk.ru/ai_image_generation/f-team/styles/oil.png',
        key: 'oil',
    },
    {
        name: 'Мультфильм',
        image_url: 'https://cloud-divkit-images.cdn-vk.ru/ai_image_generation/f-team/styles/cartoon.png',
        key: 'cartoon',
    },
    {
        name: '3D',
        image_url: 'https://cloud-divkit-images.cdn-vk.ru/ai_image_generation/f-team/styles/3d.png',
        key: '3d',
    },
    {
        name: 'Пиксель арт',
        image_url: 'https://cloud-divkit-images.cdn-vk.ru/ai_image_generation/f-team/styles/pixel.png',
        key: 'pixel',
    },
    {
        name: 'Аниме',
        image_url: 'https://cloud-divkit-images.cdn-vk.ru/ai_image_generation/f-team/styles/anime.png',
        key: 'anime',
    },
    {
        name: 'Киберпанк',
        image_url: 'https://cloud-divkit-images.cdn-vk.ru/ai_image_generation/f-team/styles/cyberpunk.png',
        key: 'cyberpunk',
    },
    {
        name: 'Комикс',
        image_url: 'https://cloud-divkit-images.cdn-vk.ru/ai_image_generation/f-team/styles/comic.png',
        key: 'comic',
    },
    {
        name: 'Фото',
        image_url: 'https://cloud-divkit-images.cdn-vk.ru/ai_image_generation/f-team/styles/realism1.png',
        key: 'realism',
    },
];

const aiPhotoGenerationSuggestionDefault: string[] = ['Девушка из аниме', 'Пейзаж Фэнтези', 'Космический кот', 'Мужчина в стиле киберпанк'];

const DISABLE_FEATURE = IS_PHONE_BROWSER || IS_DOCUMENTS_DOMAIN || IS_ONPREMISE || IS_MY_TEAM || ANONYM_USER || IS_SOCIAL_USER;

export const aiPhotoGenerationEnabled = !DISABLE_FEATURE && isFeature('ai_image_generation_enabled');
export const aiPhotoGenerationSuggestion: string[] = getFeature('ai_image_generation_suggestion') || aiPhotoGenerationSuggestionDefault;
export const aiPhotoGenerationStyles: IAiPhotoGenerationStyleItem[] =
    getFeature('ai_image_generation_styles') || aiPhotoGenerationStylesDefault;
export const aiPhotoGenerationPaidLimit: number = getFeature('ai_image_generation_paid_limit') || 20;
export const aiPhotoGenerationFreeLimit: number = getFeature('ai_image_generation_free_limit') || 1;

type TariffsModalSettings = {
    title: string;
    tariffsNumber: string;
    activeTab: string;
};

const defaultModalSettings: TariffsModalSettings = {
    title: 'Изображения с нейросетью — в подписке Mail Space',
    tariffsNumber: '56',
    activeTab: 'm',
};

const nameShowAnalytics = 'modal-show';
const nameClickAnalytics = 'modal-click';

export const aiPhotoGenerationTariffs: TariffsModalSettings = getFeature(`${FEATURE}-tariffs`);

export const aiPhotoGenerationTariffsModal = {
    paySource: AI_PHOTO_GENERATION_PAY_SOURCE,
    name: 'ai-photo-generation',
    enabled: !IS_CORP_USER && !IS_PAID_USER,
    buyTitle: aiPhotoGenerationTariffs?.title || defaultModalSettings.title,
    tariffsNumber: aiPhotoGenerationTariffs?.tariffsNumber || defaultModalSettings.tariffsNumber,
    activeTab: aiPhotoGenerationTariffs?.activeTab || defaultModalSettings.activeTab,
    actionShow: nameShowAnalytics,
    actionClick: nameClickAnalytics,
};

export const aiPhotoGenerationPromoQuotaTariffFeature: boolean = isFeature(`${FEATURE}-tariff-feature`);

export const aiPhotoGenerationDebug = isFeature(`${FEATURE}-debug`);
export const aiPhotoGenerationDebugLogger = new DebugLogger({ DEBUG_SCOPE: 'AiPhotoGenerationDebug', DEBUG: aiPhotoGenerationDebug });

export const aiPhotoGenerationPromoBanner = isFeature(`${FEATURE}-promo-banner`);
export const aiPhotoGenerationPromoBannerShowConfig = getFeature(`${FEATURE}-promo-banner-config`) || {
    showLimit: 3,
    showInterval: 2 * 24 * 60 * 60 * 1000,
};

export const aiPhotoGenerationPromoForCreateMenu = isFeature(`${FEATURE}-promo-for-create-menu`);

/** id промо модалки - для включения нужно будет включать фичу 3promo-enable-{PROMO_MODAL_ID} */
export const PROMO_MODAL_ID = `${FEATURE}-entry-point-modal`;

export const modalConfig = getFeature(`${PROMO_MODAL_ID}-config`) || {
    showLimit: 3,
    closeLimit: 3,
    showInterval: 60 * 60 * 24 * 2,
};
